import React, { useState, useCallback, useRef } from 'react';
import { storage } from '../utils/localStorage';

const storageKey = (screenId: string) => `colwidths_${screenId}`;

const MIN_WIDTH = 60;

export const useColumnWidths = (screenId: string) => {
    const [widths, setWidths] = useState<Record<string, number>>(() => {
        try {
            const raw = storage.getItem(storageKey(screenId));
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    });

    const widthsRef = useRef(widths);
    widthsRef.current = widths;

    const startResize = useCallback((columnId: string, startWidth: number, e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const startX = e.clientX;

        const onMove = (ev: MouseEvent) => {
            const next = Math.max(MIN_WIDTH, startWidth + (ev.clientX - startX));
            setWidths(prev => {
                const updated = { ...prev, [columnId]: next };
                widthsRef.current = updated;
                return updated;
            });
        };
        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            document.body.style.userSelect = '';
            storage.setItem(storageKey(screenId), JSON.stringify(widthsRef.current));
        };

        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }, [screenId]);

    const resetWidths = useCallback(() => {
        storage.removeItem(storageKey(screenId));
        widthsRef.current = {};
        setWidths({});
    }, [screenId]);

    return { widths, startResize, resetWidths };
};